import { formatDMYWithTime } from '@lbcamden/shared-utils';
import { DateTime } from 'luxon';

import { saveFile } from '~/client/utils/file';
import { RecommendedActionsReportItem } from '~/common/types/pcfra';

export const downloadRecommendedActionsReportCsv = (rows: RecommendedActionsReportItem[]) => {
  const headers = [
    'Party ref',
    'Resident name',
    'Resident address (at time of PCFRA)',
    'PCFRA approved date',
    'Action type',
    'Priority',
    'Notes',
  ];

  const escapeCell = (value: string | number | Date) => {
    const str = value instanceof Date ? formatDMYWithTime(value) : String(value);
    return /[,"\n]/.test(str) ? `"${str.replace(/"/g, '""')}"` : str;
  };

  const csv = [
    headers.join(','),
    ...rows.map((row) =>
      [
        row.personId,
        row.personName,
        row.personAddress,
        row.pcfraApprovedDate,
        row.type,
        row.priority,
        row.notes,
      ]
        .map(escapeCell)
        .join(','),
    ),
  ].join('\n');

  saveFile(
    new Blob([csv], { type: 'text/csv' }),
    `recommended-actions-report-${DateTime.now().toISODate()}.csv`,
  );
};
